module.exports = __webpack_public_path__ + "img/303208a.webp";